import { Skeleton } from '@repo/ui/components/ui/skeleton';
import { useScreenSize } from '@repo/ui/hooks';

export const JuryStageLoading = () => {
  const { isSmall } = useScreenSize();
  return isSmall ? <JuryStageMobileLoading /> : <JuryStageDesktopLoading />;
};

function JuryStageDesktopLoading() {
  return (
    <div className="flex gap-4 w-full">
      <Skeleton className="w-1/6 h-[85vh]" />
      <Skeleton className="flex flex-1 h-[85vh]" />
    </div>
  );
}

function JuryStageMobileLoading() {
  return (
    <div className="grid gap-4 w-full">
      {Array.from({ length: 12 }).map((_, index) => (
        <Skeleton className="h-16" key={index} />
      ))}
    </div>
  );
}

export default JuryStageLoading;
